import { ChartType, } from '../../../../../types/savedCharts';
export const getTableChartConfig = () => ({
    type: ChartType.TABLE,
});
//# sourceMappingURL=getTableChartConfig.js.map